import { Box, Text } from '@fozito/common-ui';
import { get } from 'lodash';
import { ICustomerMembership } from 'modules/customer/widgets/AddCustomer/type';
import { formatCurrency } from 'utils/formatCurrency';
import bronze_icon from './bronze.svg';
import gold_icon from './gold.svg';
import silver_icon from './silver.svg';

const configs = {
  'DIAMOND': {
    icon: gold_icon,
    label: 'VIP Diamond Member',
    color: '#FFF7E5',
  },
  'GOLD': {
    icon: silver_icon,
    label: 'VIP Gold Member',
    color: '#CCD4DC',
  },
  'PLATINUM': {
    icon: bronze_icon,
    label: 'VIP Platinum Member',
    color: '#FDF6F4',
  },
};
const getDiscount = (value?: ICustomerMembership | null) => {
  if (value?.discountType === 'PERCENT') return `${value.discountValue}%`;
  return formatCurrency(value?.discountValue);
};
type Props = {
  value?: ICustomerMembership | null;
};
const LoyaltyCustomer = ({ value: membership }: Props) => {
  const config = get(configs, membership?.packageType || '');

  if (!config) return null;

  return (
    <Box display='flex' alignItems='center' background={config.color} padding={'4px 16px'}>
      <Box display='flex' alignItems='center' flex={1} gap={8}>
        <img src={config.icon} alt={config.label} style={{ width: 42, height: 'auto' }} />
        <Box display='flex' alignItems='center'>
          <Text title_h4_24_medium>{config.label}</Text>
        </Box>
      </Box>
      <Text title_h5_24_semibold>{getDiscount(membership)} Disc</Text>
    </Box>
  );
};

export default LoyaltyCustomer;
